import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

export interface SelectableFilterOption {
  label: string;
  value: string;
  selected: boolean;
}

/**
 * Document categories column with select/deselect-all checkbox.
 */
@Component({
  selector: 'app-filter-categories-list',
  templateUrl: './filter-categories-list.component.html',
  styleUrls: ['./filter-categories-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterCategoriesListComponent {
  @Input() categories: SelectableFilterOption[] = [];
  @Input() control: UntypedFormControl;

  @Output() toggleAll = new EventEmitter<void>();
  @Output() toggleOption = new EventEmitter<SelectableFilterOption>();

  get allSelected(): boolean {
    return (
      this.control?.value?.length === this.categories?.length &&
      this.categories?.length > 0
    );
  }

  categoriesTooltip(): string {
    if (this.control.value?.length !== this.categories?.length) {
      return 'Select all categories';
    } else {
      return 'Deselect all categories';
    }
  }
}
